import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { toast } from "@/components/Toaster"; // the repo's toast (VS + dashboard use this; kinds: success | error | info — NO `warning`)
import { getStation } from "../api/client";
import { useStationStore } from "../state/station-store";

/** Loads the one-shot station payload into the station store; bounces to the
 *  queue on a load failure (mirrors the VS's R-140 doc-load failure UX). */
export function useStationLoad(batchId: string | undefined): { loading: boolean } {
  const [loading, setLoading] = useState(true);
  const loadPayload = useStationStore((s) => s.loadPayload);
  const navigate = useNavigate();
  useEffect(() => {
    if (!batchId) return;
    let cancelled = false;
    setLoading(true);
    getStation(batchId)
      .then((payload) => {
        if (cancelled) return;
        loadPayload(payload);
        setLoading(false);
        if (payload.claimedByOther) toast.info("Another operator is working this batch — your changes may conflict.");
      })
      .catch((err) => {
        if (cancelled) return;
        toast.error(`Couldn't open this batch: ${err instanceof Error ? err.message : "unknown error"}`);
        navigate("/queues");
      });
    return () => { cancelled = true; };
  }, [batchId, loadPayload, navigate]);
  return { loading };
}
